module.exports = __webpack_public_path__ + "static/media/invalid-warning-icon.0fe5f874.svg";